module.exports = __webpack_public_path__ + "media/images/icon-photo-f5a53b77e422a351dffa2956b8719dcb.svg";